import React from "react";
import { Dropdown, Button } from "antd";
import type { MenuProps } from "antd";
import { Plus, Users, ChevronDown } from "lucide-react";
import { useBooking } from "~/store";
import { useClientStore } from "../../client-management/clients/clients.store";

export const QuickActions: React.FC = () => {
  const { openBookingModal } = useBooking();
  const { openClientModal } = useClientStore();

  const items: MenuProps["items"] = [
    {
      key: "new-booking",
      label: (
        <div className="flex items-center space-x-2 py-1">
          <Plus size={16} />
          <span>New Booking</span>
        </div>
      ),
      onClick: () => openBookingModal({}),
    },
    {
      key: "add-client",
      label: (
        <div className="flex items-center space-x-2 py-1">
          <Users size={16} />
          <span>Add Client</span>
        </div>
      ),
      onClick: () => openClientModal(),
    },
  ];

  return (
    <div>
      <Dropdown menu={{ items }} trigger={["click"]}>
        <Button
          type="default"
          size="large"
          className="flex items-center space-x-2"
        >
          <span className="font-medium">Quick Actions</span>
          <ChevronDown size={16} />
        </Button>
      </Dropdown>
    </div>
  );
};